import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';

const FloatingActions = () => {
    const whatsappNumber = '918272873865';
    const phoneNumber = '918272873865';

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
            {/* Phone Call Button */}
            <motion.a
                href={`tel:+${phoneNumber}`}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="w-14 h-14 bg-primary text-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary-dark transition-colors duration-300"
                title="Call Us"
            >
                <Phone size={24} />
            </motion.a>

            {/* WhatsApp Button */}
            <motion.a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#128C7E] transition-colors duration-300"
                title="Chat on WhatsApp"
            >
                <MessageCircle size={28} />
            </motion.a>
        </div>
    );
};

export default FloatingActions;
